// Note: Javascript has issues with floating point arithmetic and makes entries like 1.015 multiplied by 100 to 101.49999999...
// Adding the Number.EPSILON to the cube count before multiplying by 100 addresses this issue

export const epsilonRounding = (value: number) => {
	return Math.round((value + Number.EPSILON) * 100) / 100;
};
